module.exports = __webpack_public_path__ + "img/icon-data03.f0e976b1.png";